// src/components/GearCard.jsx
// Reusable affiliate gear card with disclosure
// Add this file to src/components/

import { GEAR_ITEMS, AFFILIATE_DISCLOSURE } from "../data/content";

function GearCard({ item }) {
  return (
    <a
      href={item.affiliateUrl}
      target="_blank"
      rel="noopener noreferrer sponsored"
      className="gear-card"
    >
      <div className="gear-card-icon">{item.icon}</div>
      <div className="gear-card-body">
        <div className="gear-card-category">{item.category}</div>
        <div className="gear-card-name">{item.name}</div>
        <p className="gear-card-desc">{item.description}</p>
        <div className="gear-card-tag">{item.tag}</div>
      </div>
      <div className="gear-card-cta">
        <span className="gear-card-btn">View on Amazon ↗</span>
        <span className="gear-card-used">
          Used in: {item.usedIn.join(", ")}
        </span>
      </div>
    </a>
  );
}

export default function GearSection({ gearIds }) {
  const items = gearIds
    ? GEAR_ITEMS.filter((g) => gearIds.includes(g.id))
    : GEAR_ITEMS;

  // Group by category
  const categories = [...new Set(items.map((g) => g.category))];

  return (
    <div className="gear-section">
      <div className="gear-disclosure">
        <span className="gear-disclosure-icon">ℹ️</span>
        {AFFILIATE_DISCLOSURE}
      </div>

      {categories.map((cat) => (
        <div key={cat} className="gear-category-group">
          <h3 className="gear-category-title">{cat}</h3>
          <div className="gear-grid">
            {items
              .filter((g) => g.category === cat)
              .map((item) => (
                <GearCard key={item.id} item={item} />
              ))}
          </div>
        </div>
      ))}
    </div>
  );
}